module.exports = __webpack_public_path__ + "img/Frame 3@2x.ce2a853d.png";